import React, { useState } from 'react';
import { api } from '../lib/api';
import { toast } from 'sonner';
import { FileDown, MessageCircle, Mail, Bell } from 'lucide-react';
import { waLink } from '../lib/share';

// Compartir recibo / ticket / factura: PDF, WhatsApp, correo y notificación interna.
// El usuario elige ver/imprimir en Dólares ($) o Bolívares (Bs) con la Tasa BCV del día.
export const DocShare = ({ kind, refId, phone, label = 'Documento', compact }) => {
  const [cur, setCur] = useState('USD');
  const q = cur === 'BS' ? '?currency=bs' : '';
  const link = async () => (await api.docLink(kind, refId)).data.url + q;
  const run = async (fn) => { try { await fn(); } catch (e) { toast.error(e.response?.data?.detail || 'SalesPRO: Error'); } };
  const cls = 'inline-flex items-center gap-1 text-xs px-2 py-1 rounded-md';
  const curBtn = (code, txt) => (
    <button key={code} onClick={() => setCur(code)} data-testid={`doc-cur-${code.toLowerCase()}-${refId}`}
      className={`text-[11px] px-2 py-1 rounded-md font-semibold ${cur === code ? 'bg-[#FFC857] text-[#022C22]' : 'bg-slate-100 text-slate-500'}`}>{txt}</button>
  );
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={`docshare-${kind}-${refId}`}>
      <span className="inline-flex gap-1 mr-1" title="Moneda del documento">{curBtn('USD', '$')}{curBtn('BS', 'Bs')}</span>
      <button className={`${cls} bg-[#022C22] text-white`} data-testid={`doc-pdf-${refId}`} onClick={() => run(async () => window.open(await link(), '_blank'))}><FileDown size={12} /> {compact ? 'PDF' : `${label} PDF`}</button>
      <button className={`${cls} bg-green-50 text-green-700`} data-testid={`doc-wa-${refId}`} onClick={() => run(async () => window.open(waLink(phone, `${label} Celular Beach: ${await link()}`), '_blank'))}><MessageCircle size={12} /> WhatsApp</button>
      {kind !== 'vendor_invoice' && <>
        <button className={`${cls} bg-blue-50 text-blue-700`} data-testid={`doc-email-${refId}`} onClick={() => run(async () => { const r = await api.docEmail(kind, refId); toast.success(`SalesPRO: Enviado a ${r.data.to}`); })}><Mail size={12} /> Correo</button>
        <button className={`${cls} bg-amber-50 text-amber-700`} data-testid={`doc-notify-${refId}`} onClick={() => run(async () => { await api.docNotify(kind, refId); toast.success('SalesPRO: Notificado al cliente'); })}><Bell size={12} /> Notificar</button>
      </>}
    </div>
  );
};

export default DocShare;
